import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row, InputGroup } from 'react-bootstrap';
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik';
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { BiUser } from "react-icons/bi";
import { useDispatch } from "react-redux";
import Cookies from 'js-cookie';
import { jwtDecode } from "jwt-decode";
import { FaEye, FaEyeSlash } from 'react-icons/fa6';
import { config } from '../Components/CommonUtilities/CommonUrl/CommonUrls';
import axios from 'axios';
import { TfiReload } from 'react-icons/tfi';
import { CommomLoginAunthenticatePost, CommonAxiosGet } from '../Components/CommonUtilities/CommonAxios/CommonAxios';
import Sweetalert from '../Components/CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import { CONTEXT_HEADING, ERROR_MSG, handleInputToUppercase, USERNAME_REG } from '../Components/CommonUtilities/Validations/RegularExpAndVar';
import { handleLogout, initialFormValues } from './EmployeeLogin';
import { FaAddressCard, FaRegAddressCard } from 'react-icons/fa';

const userValidationSchema = Yup.object().shape({
  username: Yup.string().required(ERROR_MSG),
  // .matches(USERNAME_REG, 'Invalid User Id'),
  password: Yup.string().required(ERROR_MSG),
  captcha: Yup.string().required(ERROR_MSG),
});
// Utility to fetch captcha
const fetchCaptcha = async (setRefreshCaptcha, formik) => {
  try {
    const url = config.url.DSC_URL + "dsc-public/generate-captcha";
    const res = await axios.post(url);
    if (res?.data?.status === true) {
      setRefreshCaptcha(res.data.captcha);
      formik.setFieldValue('captchaId', res.data.captchaId);
      formik.setFieldValue('captcha', "");
    }
  } catch (error) {
    console.error("Error fetching captcha", error);
  }
};

// Utility to authenticate user

export function DecodeAuthToken(resdata, dispatch, navigate) {
  const decoded = jwtDecode(resdata?.access_token);
  // console.log("decoded:::", decoded)
  const tokenExpiry = new Date(decoded.exp * 1000);
  const refreshExpiry = new Date(jwtDecode(resdata?.refresh_token).exp * 1000);
  Cookies.set("token", resdata?.access_token, { expires: tokenExpiry });
  Cookies.set("refreshToken", resdata?.refresh_token, { expires: refreshExpiry });
  dispatch({
    type: "SHOW_LOGIN_DETAILS",
    payload: {
      isLoggedIn: true, loginData: decoded, userType: resdata?.user_type, roleServices: resdata?.services_list,
      isLoginActive: decoded?.login_active,
    }
  });
  casteData(dispatch);
  if (decoded?.role_id === 2) {
    getTabData(dispatch, navigate);
  }
}
const authenticateUser = async (values, navigate, dispatch, setRefreshCaptcha, formik) => {
  try {
    const url = config.url.DSC_URL + "auth/candidate-authenticate";
    const res = await CommomLoginAunthenticatePost(url, values);
    if (res.data.scode === "01") {
      let datar = res?.data
      DecodeAuthToken(datar, dispatch, navigate);
    } else {
      fetchCaptcha(setRefreshCaptcha, formik);
      Sweetalert(res.data.sdesc, 'error');
    }
  } catch (error) {
    console.error("Login error", error);
  }
};
// Fetch initial data for tab status
export const getTabData = async (dispatch, navigate) => {
  const url = config.url.DSC_Read_URL + "tab-status";
  try {
    const res = await CommonAxiosGet(url);
    if (res?.data?.status === true) {
      const latestTab = res?.data?.tabdata_status ? parseInt(res?.data?.tabdata[0]?.current_tab) : 1;
      const confirmation = res?.data?.confirmation_status ? res?.data?.confirmation[0]?.basic_education_check : false;
      dispatch({ type: "SHOW_TAB_DETAILS", payload: { latestTab, confirm: confirmation } });
      navigate('/DashboardHome')
      // if (latestTab === 4) {
      //   navigate('/DashboardHome');//HallTicketFinal
      // }
      // else {
      //   Sweetalert('Applications are Closed', 'warning')
      // }
    }
  } catch (error) {
    console.error("Error fetching data", error);
  }
};
export const casteData = async (dispatch) => {

  let casteUrl = config.url.DSC_Read_URL + "dsc-public/sub-castes";
  const response = await axios.get(casteUrl);
  if (response?.data?.status === true) {
    let totCaste = response?.data?.data || []
    const uniqueCasteNames = [...new Set(response?.data?.data?.map(item => item.caste_name))];
    const uniqueCasteCodes = [...new Set(response?.data?.data?.map(item => item.caste_code))];
    const casteList = uniqueCasteNames?.map((subcaste) => ({ value: subcaste, label: subcaste }))
    dispatch({ type: "SHOW_CASTE_DETAILS", payload: { totalCasteList: totCaste, casteList: casteList, casteCodeList: uniqueCasteCodes } });
  }
}
// Main component
export default function CandidateLogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showUserPwd, setShowUserPwd] = useState(true);
  const [refreshCaptcha, setRefreshCaptcha] = useState("");
  const formik = useFormik({
    initialValues: initialFormValues,
    validationSchema: userValidationSchema,
    onSubmit: (values) => authenticateUser(values, navigate, dispatch, setRefreshCaptcha, formik)
  });

  useEffect(() => {
    fetchCaptcha(setRefreshCaptcha, formik);
    handleLogout(dispatch, navigate);
  }, [dispatch, navigate]);

  const togglePasswordVisibility = (id) => {
    const passwordInput = document.getElementById(id);
    passwordInput.type = passwordInput.type === "password" ? "text" : "password";
  };
  return (
    <FormikProvider value={formik}>
      <Row> <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
        <div className='text-center text-danger text-error'><h6> ***  AP TET - 2026 Applications is closed ***  </h6></div>
        {/* {CONTEXT_HEADING === "TET" &&
          <div className='text-center'><button onClick={() => { navigate('/RegistrationForm') }} className='btn btn-success text-white rounded-0 fw-normal'><FaRegAddressCard />&nbsp;New Registration?</button></div>
        } */}
        <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit} className='nyay-form mt-3 mt-md-3'>
          <InputGroup className="mb-3"><InputGroup.Text id="basic-addon1" className="group_txt"><BiUser className="font_size" /></InputGroup.Text>
            <Field type="text" name="username" placeholder="Enter Your User Name" className="input-field form-control"
              onInput={(e) => { handleInputToUppercase(e) }}
              maxLength='11' />
            <ErrorMessage name="username" component="div" className="text-error" /></InputGroup>
          <InputGroup className="mb-3"><InputGroup.Text id="basic-addon2" className="group_txt">
            {showUserPwd ? (<FaEyeSlash className="font_size" onClick={() => { togglePasswordVisibility("pwd"); setShowUserPwd(false); }} />) :
              (<FaEye className="font_size" onClick={() => { togglePasswordVisibility("pwd"); setShowUserPwd(true); }} />)} </InputGroup.Text>
            <input type="password" placeholder="Password" id='pwd' name="password" className="form-control" maxLength='30' autoComplete="off"
              onChange={(e) => formik.setFieldValue('password', e.target.value)} /><ErrorMessage name="password" component="div" className="text-error" /> </InputGroup>
          <InputGroup className="mb-3"><TfiReload onClick={() => fetchCaptcha(setRefreshCaptcha, formik)} size={20} className="mt-2" />
            &nbsp;<img height={40} width={100} src={refreshCaptcha} alt="captcha" />&nbsp;&nbsp;
            <Field className="form-control" type="text" name="captcha" placeholder="Captcha" maxLength="6" autoComplete="off" />
            <ErrorMessage name="captcha" component="div" className="text-error" /></InputGroup>
          <Button variant="" type="submit" className='w-100 sign-in-button'> Sign in</Button> </Form>
        <div className='mt-3'><a href='/ForgotPassword' className='float-left'>Forgot Password?</a><a href='/KnowUserId' className='float-end'>Know your User Id?</a></div>
      </Col> </Row></FormikProvider>
  );
}
